import { ecoTagLabelMap, EcoTagType } from "../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../redux/store";
import { getEcoBadgeType } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { useBnbOptionalLabel } from "../../utils/labels";
import type { EcolabelType } from "../../../../../common-deprecated/constants";

type DataType = {
    ecoBadge: EcolabelType | false;
    label: string;
    available: { label: string; position: string };
};

/**
 * Only used in newer Build versions. Updates here will probably require updates in common/atoms/EcoTag
 */
const useEcoTag = (type?: EcoTagType | false): DataType => {
    const ecoBadge = useBnbSelector((state) => getEcoBadgeType(state.commonSettings, type, state.navigation.model));
    const hybridAvailableLabel = useBnbOptionalLabel("hybridAvailable");
    const hybridLabel = useBnbOptionalLabel("hybrid");

    const labelKey = ecoTagLabelMap[type === EcoTagType.Available ? EcoTagType.Hybrid : type || ("" as EcoTagType)];
    let label = useBnbOptionalLabel(labelKey!) || "";

    // fallback when label is empty since plugins are a type of hybrids
    if (!label && type === EcoTagType.Plugin) label = hybridLabel || "";

    const available = { label: "", position: "" };
    if (type === EcoTagType.Available) {
        // In some languages "available" is in front of "hybrid", calculate placement accordingly.
        const parsedLabel = hybridAvailableLabel || "";
        available.position = parsedLabel.indexOf(label) > parsedLabel.indexOf(available.label) ? "left" : "right";
        available.label = parsedLabel.replace(label, "");
    }

    return {
        ecoBadge,
        label,
        available,
    };
};

export default useEcoTag;
